import { t } from '@lingui/core/macro';
import { NoddiAsyncError } from 'noddi-types';
import { ErrorMessage } from 'noddi-ui-web';
import { ApiErrorMessageWithTrans } from '../Error/ApiErrorMessageWithTrans';

const isMissingFieldError = (addressError: NoddiAsyncError, field: string) =>
  addressError.response?.data.errors?.some(({ attr }) => attr === field) ?? false;

export const AddressError = ({ addressError }: { addressError: NoddiAsyncError | null }) => {
  if (!addressError) {
    return null;
  }

  if (addressError.response?.data.errors?.some(({ code }) => code === 'incomplete_address')) {
    return (
      <ErrorMessage
        message={t`The selected address does not contain enough information. Please select a more specific address with street number, street name, zip code and city.`}
      />
    );
  }

  if (isMissingFieldError(addressError, 'street_number')) {
    return <ErrorMessage message={t`Please select an address with a valid street number`} />;
  }

  if (isMissingFieldError(addressError, 'street_name')) {
    return <ErrorMessage message={t`Please select an address with a valid street name`} />;
  }

  if (isMissingFieldError(addressError, 'zip_code')) {
    return <ErrorMessage message={t`Please select an address with a valid zip code`} />;
  }

  if (isMissingFieldError(addressError, 'city')) {
    return <ErrorMessage message={t`Please select an address with a valid city`} />;
  }

  return <ApiErrorMessageWithTrans error={addressError} />;
};
